"use client";

import React from "react";

import CoverFor from "@/app/components/cover-for";
import CoverForProvider from "@/app/components/cover-for/provider/cover-for.provider";
import { CoverForPageType } from "@/app/components/cover-for/types/cover-for.type";

function CoverForPage({ cmsData }: CoverForPageType) {
  return (
    <CoverForProvider initialValue={cmsData}>
      <CoverFor />
    </CoverForProvider>
  );
}

export default CoverForPage;
